<div
   class="trasparent-div"
   *ngIf="isSmallView"
   kendoTooltip
   [tooltipTemplate]="tooltipTemplate"
   (click)="onBrickClick()"
   [title]="currentUserStatusInfo$.customStatusName | async"
>
   <ng-template #tooltipTemplate>
      <samweb-agent-status [statusInfo]="currentUserStatusInfo$ | async" [hideIcon]="true"></samweb-agent-status>
   </ng-template>
</div>
<div
   fxLayout="column"
   fxLayoutAlign="center"
   fxFill
   [samwebUserStatusClass]="currentUserStatusInfo$ | async"
   class="main-div"
   (click)="onBrickClick()"
>
   <div class="dropdown-hidden">
      <samweb-user-status-dropdown #userStatusDropdown fxFlex="1 1 auto"> </samweb-user-status-dropdown>
   </div>

   <div fxLayoutAlign="center center" fxFlex="2 1 auto">
      <div class="presence-time" *ngIf="showDurationAsText$ | async">
         <ng-container *ngIf="currentUserStatusDuration$ | async | amIsAfter: (now$ | async); else noTimer">
            {{ currentUserStatusDuration$ | amTimeAgoUpdateEverySecond$ | durationToText$ | async }}
         </ng-container>
      </div>
      <ng-template #noTimer> - </ng-template>
   </div>

   <div *ngIf="!isSmallView">
      <div fxLayoutAlign="center center" fxFlex="1 1 auto" *ngIf="currentUserStatusInfo$ | async as userStatsInfo">
         <samweb-agent-status [statusInfo]="userStatsInfo" [hideIcon]="true"></samweb-agent-status>
      </div>
   </div>

   <samweb-user-status-progressbar
      [showProgressbar]="showProgress$ | async"
      [userId]="userId | async"
   ></samweb-user-status-progressbar>
</div>
